import styled from 'styled-components';
import { getThemeProp } from 'theme';

export const SCommonModalHeader = styled.div`
  color: red;
  display: flex;
  align-items: center;

  // first child is arrow-back
  & > *:nth-child(1) {
    color: ${getThemeProp('colors.chetwodeBlue3')};
    padding: 6px;
    margin-right: 27px;

    &:hover {
      color: ${getThemeProp('colors.havelockBlue')};
      background: ${getThemeProp('colors.zumthorBlue')};
      border-radius: 50%;
    }
    cursor: pointer;
  }

  // third child is notification warning icon
  & > *:nth-child(3) {
    margin-right: 12px;
  }
`;

export const SVerticalLine = styled.span`
  height: 32px;
  width: 1px;
  transform: scaleY(-1);
  background-color: ${getThemeProp('colors.mercuryGrey')};
  position: absolute;
  left: calc(50px + 18px + 20px);
`;

export const SCommonModalHeaderTextContainer = styled.div`
  height: 28px;
  color: ${getThemeProp('colors.fiordGrey')};
  font-size: 20px;
  line-height: 28px;
`;

export const SCommonModalFooter = styled.div`
  display: flex;
  height: 34px;
  justify-content: flex-end;

  > * :nth-child(1) {
    margin-right: 32px;
  }
`;
